import React, { useEffect, useState } from 'react';
import { Button, Col, Row } from 'reactstrap';
import { faEdit, faSave } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

//Components
import TextField from '../../../../../components/TextField';

// Helpers
import { objCampo, validarCampos } from '../../../../../helpers/ValidadorDeCampos';
import { showMessage } from '../../../../../helpers/message';

// Context
import { useAuth } from '../../../../../context/auth';

//API
import perfil_api from '../../../../../api/perfil_api';
import usuario_api from '../../../../../api/usuario_api';

function Identificacao({ usuario, setUsuario, loadUsuarioItem, editavel }) {

    const { setLoading } = useAuth();

    //State de controle dos erros nos campos
    const [errors, setErrors] = useState({});

    //State para pegar os perfil
    const [listaPerfil, setListaPerfil] = useState([]);

    //Função para pegar lista de perfil
    const loadPerfil = () => {
        setLoading(true);
        perfil_api.getList().then(response => {
            response.data.map(value => {
                value.label = value.identificacao;
                value.value = value.id.toString();
                return value;
            })
            setListaPerfil(response.data)
        })
            .catch(err => showMessage("Aviso", err.message, "error", null))
            .finally(() => setLoading(false))
    }

    useEffect(() => {
        loadPerfil();
    }, []);

    //Campos obrigatorios
    const camposIdentificacao = [
        objCampo({ name: "nome", required: true }),
        objCampo({ name: "email", required: true }),
        objCampo({ name: "status", required: true }),
        objCampo({ name: "perfil_Id", required: true })
    ];

    //Função de onChange dos campos
    const onChange = (e) => {
        const { name, value } = e.target;
        const _usuario = {
            ...usuario
        };

        const _campos = camposIdentificacao.filter(campo => campo.name == name);
        const fieldError = validarCampos(_usuario, _campos);

        const _errors = { ...errors };
        delete _errors[name];
        if (fieldError[1].length === 0)
            setErrors({ ..._errors });
        else
            setErrors({ ..._errors, ...fieldError[0] });

        setUsuario({
            ...usuario,
            [name]: value
        })
    }

    //Função de onChange dos campos select
    const onChangePerfil = (value, e) => {
        const _usuario = {
            ...usuario,
            [e.name]: value ? value.value : null,
        };

        const _campos = camposIdentificacao.filter(campo => campo.name == e.name);
        const fieldError = validarCampos(_usuario, _campos);

        const _errors = { ...errors };
        delete _errors[e.name];
        if (fieldError[1].length === 0)
            setErrors({ ..._errors });
        else
            setErrors({ ..._errors, ...fieldError[0] });


        setUsuario(_usuario);
    }

    //Função para salvar usuario
    const salveUsuario = () => {
        const _errors = validarCampos(usuario, camposIdentificacao);
        setErrors(_errors[0]);

        if (_errors[1].length > 0)
            return true;

        const _usuario = { ...usuario }

        if (_usuario.id) {
            setLoading(true);
            usuario_api.put(_usuario)
                .then(response => {
                    showMessage("Aviso", "Dados de identificacao do Usuario Atualizado com Sucesso", "success", () => loadUsuarioItem());
                })
                .catch(e => showMessage("Erro", e.message, "error", null))
                .finally(() => setLoading(false));
        } else {
            setLoading(true);
            usuario_api.post(_usuario)
                .then(response => {
                    showMessage("Aviso", "Dados de identificacao do Usuario Criado com Sucesso", "success", () => loadUsuarioItem(response.data.id));
                })
                .catch(e => showMessage("Erro", e.message, "error", null))
                .finally(() => setLoading(false));
        }
    }

    return <>
        <Row>
            <h5 className='mb-3'>Identificacao do Usuario</h5>
            <Col md="12" lg="6">
                <TextField
                    name={"nome"}
                    label={"* Nome"}
                    value={usuario.nome}
                    invalid={!!errors.nome}
                    onChange={onChange}
                    disabled={!editavel}
                />
            </Col>
            <Col md="12" lg="6">
                <TextField
                    name={"email"}
                    label={"* Email"}
                    type={"email"}
                    invalid={!!errors.email}
                    value={usuario.email}
                    onChange={onChange}
                    disabled={!editavel}
                />
            </Col>
            <Col md="12" lg="8">
                <TextField
                    name={"perfil_Id"}
                    label={"* Perfil"}
                    type={"select"}
                    searchable
                    options={listaPerfil}
                    invalid={!!errors.perfil_Id}
                    onChange={onChangePerfil}
                    value={listaPerfil.filter(value => value.value == usuario.perfil_Id)}
                    disabled={!editavel}
                />
            </Col>
            <Col md="12" lg="4">
                <TextField
                    name={"status"}
                    label={"* Status"}
                    type={"radio"}
                    value={usuario.status}
                    options={[
                        { label: "Ativo", value: "Ativo" },
                        { label: "Inativo", value: "Inativo" }
                    ]}
                    invalid={!!errors.status}
                    onChange={onChange}
                    disabled={!editavel}
                />
            </Col>
            <Row>
                {editavel &&
                    <Col md="12" lg="12" className='d-flex align-items-center justify-content-center '>
                        <Button
                            color={usuario.id ? 'warning text-white' : 'success'}
                            className='px-4'
                            onClick={salveUsuario}>
                            {usuario.id ? <><FontAwesomeIcon icon={faEdit} /> Atualizar</> : <><FontAwesomeIcon icon={faSave} /> Salvar</>}
                        </Button>
                    </Col>
                }
            </Row>
        </Row>
    </>;
}

export default Identificacao;